import { useState } from 'react'
import { Link, NavLink, useLocation } from 'react-router-dom'
import { Menu, X } from 'lucide-react'
import { NAV_LINKS, DJ_NAME } from '../data'
import { useMediaQuery, breakpoints } from '../hooks/useMediaQuery'

const SpotifyIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z" />
  </svg>
)

const InstagramIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
  </svg>
)

const YouTubeIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M23.495 6.205a3.007 3.007 0 00-2.088-2.088c-1.87-.501-9.396-.501-9.396-.501s-7.507-.01-9.396.501A3.007 3.007 0 00.527 6.205a31.247 31.247 0 00-.522 5.805 31.247 31.247 0 00.522 5.783 3.007 3.007 0 002.088 2.088c1.868.502 9.396.502 9.396.502s7.506 0 9.396-.502a3.007 3.007 0 002.088-2.088 31.247 31.247 0 00.5-5.783 31.247 31.247 0 00-.5-5.805zM9.609 15.601V8.408l6.264 3.602z" />
  </svg>
)

const TikTokIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z" />
  </svg>
)

const SOCIAL_ICONS = [
  { icon: <SpotifyIcon />,   href: 'https://open.spotify.com', label: 'Spotify' },
  { icon: <InstagramIcon />, href: 'https://www.instagram.com/dj30rack',    label: 'Instagram' },
  { icon: <YouTubeIcon />,   href: 'https://www.youtube.com/channel/UCxIbUpbL94QJWQSlF3QwTgA',      label: 'YouTube' },
  { icon: <TikTokIcon />,    href: 'https://www.tiktok.com/@dj30rack',       label: 'TikTok' },
]

export default function Nav() {
  const [mobileOpen, setMobileOpen] = useState(false)
  const isDesktop = useMediaQuery(breakpoints.lg)
  const location = useLocation()

  if (isDesktop && mobileOpen) setMobileOpen(false)

  return (
    <header
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 50,
        background: 'rgba(13,12,10,0.97)',
        borderBottom: '1px solid var(--border)',
        backdropFilter: 'blur(8px)',
        WebkitBackdropFilter: 'blur(8px)',
      }}
    >
      <nav
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '0 20px',
          height: '64px',
          maxWidth: '1440px',
          margin: '0 auto',
          gap: '16px',
        }}
      >
        {/* Logo */}
        <Link
          to="/"
          style={{
            fontFamily: 'var(--font-display)',
            fontWeight: 600,
            fontSize: isDesktop ? '18px' : '15px',
            letterSpacing: isDesktop ? '5px' : '3px',
            color: 'var(--gold)',
            textTransform: 'uppercase',
            textDecoration: 'none',
            flexShrink: 0,
          }}
        >
          {DJ_NAME}
        </Link>

        {/* Desktop: centred nav links */}
        {isDesktop && (
          <ul
            style={{
              display: 'flex',
              gap: '20px',
              listStyle: 'none',
              alignItems: 'center',
              flex: 1,
              justifyContent: 'center',
              margin: 0,
              padding: 0,
            }}
          >
            {NAV_LINKS.map((link) => {
              const isActive = location.pathname === link.href
              return (
                <li key={link.href}>
                  {link.external ? (
                    <a
                      href={link.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        fontFamily: 'var(--font-display)',
                        fontSize: '11px',
                        letterSpacing: '2.5px',
                        textTransform: 'uppercase',
                        color: 'rgba(242,236,224,0.45)',
                        textDecoration: 'none',
                        transition: 'color 0.2s',
                      }}
                      onMouseEnter={(e) => ((e.currentTarget as HTMLElement).style.color = 'var(--gold)')}
                      onMouseLeave={(e) => ((e.currentTarget as HTMLElement).style.color = 'rgba(242,236,224,0.45)')}
                    >
                      {link.label}
                    </a>
                  ) : (
                    <NavLink
                      to={link.href}
                      style={{
                        fontFamily: 'var(--font-display)',
                        fontSize: '11px',
                        letterSpacing: '2.5px',
                        textTransform: 'uppercase',
                        textDecoration: 'none',
                        color: isActive ? 'var(--gold)' : 'rgba(242,236,224,0.45)',
                        borderBottom: isActive ? '1px solid var(--gold)' : '1px solid transparent',
                        paddingBottom: '2px',
                        transition: 'color 0.2s',
                      }}
                    >
                      {link.label}
                    </NavLink>
                  )}
                </li>
              )
            })}
          </ul>
        )}

        {/* Desktop: social icons + auth */}
        {isDesktop && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexShrink: 0 }}>
            {SOCIAL_ICONS.map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={s.label}
                style={{ color: 'rgba(242,236,224,0.3)', transition: 'color 0.2s', display: 'flex' }}
                onMouseEnter={(e) => ((e.currentTarget as HTMLElement).style.color = 'var(--gold)')}
                onMouseLeave={(e) => ((e.currentTarget as HTMLElement).style.color = 'rgba(242,236,224,0.3)')}
              >
                {s.icon}
              </a>
            ))}
            <div style={{ width: '1px', height: '20px', background: 'var(--border)', margin: '0 4px' }} />
            <Link
              to="/signin"
              style={{
                fontFamily: 'var(--font-display)',
                fontSize: '11px',
                letterSpacing: '2.5px',
                textTransform: 'uppercase',
                color: 'rgba(242,236,224,0.45)',
                textDecoration: 'none',
                transition: 'color 0.2s',
              }}
              onMouseEnter={(e) => ((e.currentTarget as HTMLElement).style.color = 'var(--cream)')}
              onMouseLeave={(e) => ((e.currentTarget as HTMLElement).style.color = 'rgba(242,236,224,0.45)')}
            >
              Sign In
            </Link>
            <Link
              to="/signup"
              style={{
                fontFamily: 'var(--font-display)',
                fontWeight: 500,
                fontSize: '11px',
                letterSpacing: '2.5px',
                textTransform: 'uppercase',
                color: 'var(--ink)',
                background: 'var(--gold)',
                padding: '7px 16px',
                textDecoration: 'none',
                display: 'inline-block',
                transition: 'background 0.2s',
              }}
              onMouseEnter={(e) => ((e.currentTarget as HTMLElement).style.background = 'var(--gold-bright)')}
              onMouseLeave={(e) => ((e.currentTarget as HTMLElement).style.background = 'var(--gold)')}
            >
              Sign Up
            </Link>
          </div>
        )}

        {/* Mobile: Sign Up pill + hamburger */}
        {!isDesktop && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexShrink: 0 }}>
            <Link
              to="/signup"
              style={{
                fontFamily: 'var(--font-display)',
                fontWeight: 500,
                fontSize: '10px',
                letterSpacing: '2px',
                textTransform: 'uppercase',
                color: 'var(--ink)',
                background: 'var(--gold)',
                padding: '6px 12px',
                textDecoration: 'none',
                display: 'inline-block',
              }}
            >
              Sign Up
            </Link>
            <button
              onClick={() => setMobileOpen((o) => !o)}
              aria-label={mobileOpen ? 'Close menu' : 'Open menu'}
              aria-expanded={mobileOpen}
              style={{
                background: 'none',
                border: 'none',
                color: 'var(--cream)',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                padding: '4px',
              }}
            >
              {mobileOpen ? <X size={22} /> : <Menu size={22} />}
            </button>
          </div>
        )}
      </nav>

      {/* Mobile drawer */}
      {!isDesktop && mobileOpen && (
        <div
          style={{
            background: 'var(--ink-2)',
            borderTop: '1px solid var(--border)',
            padding: '8px 0 24px',
          }}
        >
          <ul style={{ listStyle: 'none', margin: 0, padding: '0 20px' }}>
            {NAV_LINKS.map((link) => {
              const isActive = location.pathname === link.href
              return (
                <li key={link.href} style={{ borderBottom: '1px solid rgba(200,169,110,0.08)' }}>
                  <Link
                    to={link.href}
                    onClick={() => setMobileOpen(false)}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      fontFamily: 'var(--font-display)',
                      fontSize: '13px',
                      letterSpacing: '3px',
                      textTransform: 'uppercase',
                      color: isActive ? 'var(--gold)' : 'rgba(242,236,224,0.6)',
                      textDecoration: 'none',
                      padding: '15px 0',
                    }}
                  >
                    {link.label}
                    {isActive && (
                      <span style={{ width: '4px', height: '4px', borderRadius: '50%', background: 'var(--gold)' }} />
                    )}
                  </Link>
                </li>
              )
            })}
          </ul>

          {/* Social icons */}
          <div
            style={{
              display: 'flex',
              gap: '20px',
              padding: '20px 20px 0',
              borderTop: '1px solid rgba(200,169,110,0.08)',
              marginTop: '8px',
            }}
          >
            {SOCIAL_ICONS.map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={s.label}
                style={{ color: 'rgba(242,236,224,0.35)', display: 'flex' }}
              >
                {s.icon}
              </a>
            ))}
          </div>

          {/* Auth */}
          <div style={{ display: 'flex', gap: '10px', padding: '16px 20px 0' }}>
            <Link
              to="/signin"
              onClick={() => setMobileOpen(false)}
              className="btn-ghost"
              style={{ flex: 1, justifyContent: 'center', textAlign: 'center' }}
            >
              Sign In
            </Link>
            <Link
              to="/signup"
              onClick={() => setMobileOpen(false)}
              className="btn-primary"
              style={{ flex: 1, textAlign: 'center' }}
            >
              Sign Up
            </Link>
          </div>
        </div>
      )}
    </header>
  )
}
